import { useCallback } from 'react'
import moment from 'moment-timezone'
import { useSelector } from 'react-redux'

import CafeteriaOrders from 'app/common/components/Cafeteria/CafeteriaOrders'

import {
  cafeteriaOrdersPathMask,
  params as p,
  createPath,
  getSchoolTypeExact,
  getStudentIdExact,
  getDateExact,
  monthFormat,
  dateFormat,
  isMonthly,
} from 'app/pages/routePaths'

import selectPerson, { type Person } from '../selectPerson'
import SimpleDate from 'app/dataProviders/SimpleDate'

type Props = {
  params: {
    id: string
    date: string
    schoolType: string
  }
  router: {
    replace: (pathname: string) => void
    push: (pathname: string) => void
  }
}

const OrdersPage = ({ params, router: { push } }: Props) => {
  const date = getDateExact(params)
  const id = getStudentIdExact(params)
  const schoolType = getSchoolTypeExact(params)

  const person: Person = useSelector((state) => selectPerson(state, id))
  const handleChangeDate = useCallback(
    (newDate: string, newDateFormat: string, daily: boolean = false) => {
      push(
        createPath(
          {
            [p.studentId]: id,
            [p.schoolType]: schoolType,
            [p.date]: moment(newDate, newDateFormat).format(daily ? dateFormat : monthFormat),
          },
          cafeteriaOrdersPathMask,
        ),
      )
    },
    [id, push, schoolType],
  )

  const simpleDate = new SimpleDate(date, isMonthly(date) ? monthFormat : dateFormat)

  return (
    <CafeteriaOrders
      date={simpleDate}
      dateType={isMonthly(date) ? 'month' : 'day'}
      person={person}
      onChangeDate={handleChangeDate}
    />
  )
}

export default OrdersPage
